export const SEC_FONT_GREY = "#9B9B9B";
export const BLUE_DARK = "#2955a2";
export const WHITE_GRAY = "#F5F5F5";
export const WHITE_SMOKE = "#f9f9f9";
export const DARK_GRAY = "#727272";
export const LIGHT_GRAY = "#AFAFAF";

export const GRAY = "#64666c";
export const GOLD = "#FEEFB3";
export const STEEL_BLUE = "#2854A1";
export const NEW_BLUE = "#2B56A3";
export const BLUE = "#2F549B";
export const BLUE_HOVER = "#4E70A8";
export const RED_GRAD = "#CA367E";
export const WHITE = "#fff";
export const BLACK = "#000";
export const BLACK_99 = "#00000099";
export const BLACK_4D = "#0000004D";
export const GRAY11 = "#EAECF0";
export const GRAY_200 = "#E4E7EC";
export const GRAY_100 = "#F2F4F7";
export const GRAY_300 = "#D0D5DD";
export const GRAY_400 = "#98A2B3";
export const GRAY_500 = "#667085";
export const GRAY_600 = "#475467";
export const GRAY_700 = "#344054";
export const GRAY_50 = "#F9FAFB";
export const GRAY_800 = "#1D2939";
export const GRAY_900 = "#101828";
export const GRAY_75 = "#fafafa";

export const GRAY5 = "#E0E0E0";
export const GRAY_PLACEHOLDER = "#979797";

export const PRIMARY_25 = "#F5FAFF";
export const PRIMARY_50 = "#EFF8FF";
export const PRIMARY_100 = "#D1E9FF";
export const PRIMARY_400 = "#53B1FD";
export const PRIMARY_600 = "#1570EF";
export const PRIMARY_500 = "#2E90FA";
export const PRIMARY_675 = "#2b569f";
export const PRIMARY_700 = "#175CD3";
export const PRIMARY_900 = "#194185";
export const PRIMARY_800 = "#1849A9";
export const TRANSPARENT = "transparent";

export const SUCCESS_100 = "#D1FADF";
export const SUCCESS_800 = "#05603A";

export const ERROR_50 = "#FEF3F2";
export const ERROR_100 = "#FEE4E2";
export const ERROR_600 = "#D92D20";
export const ERROR_700 = "#B42318";
export const ERROR_800 = "#93370D";

export const LIGHT_BLUE_50 = "#ECF2FF";
export const LIGHT_BLUE_100 = "#F9FBFF";
export const LIGHT_BLUE_4 = "#84CAFF";
export const BLUE_700 = "#2B569F";
export const BLUE_500 = "#2C81FF";
export const BLUE_675 = "#2B56A3";
export const BLUE_250 = "#2C56A3";
export const BLUE_DISABLED = "#BECCE3";
export const BLUE_HOVER_BUTTON = "#3E659C";
export const BLUE_DISABLED_BUTTON = "#E8EDF7";
export const BLUE_DISABLED_BUTTON_COLOR = "#90A5CC";
export const LIGHT_BLUE_6 = "#b2ddff";
